import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemCount, isBulk }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-background/80 backdrop-blur-sm z-300"
        onClick={onClose}
        aria-hidden="true"
      />

      <div 
        className="fixed inset-0 z-300 overflow-y-auto"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-confirmation-title"
      >
        <div className="flex min-h-full items-center justify-center p-24">
          <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-[500px] animate-in zoom-in-95 duration-200">
            <div className="px-32 py-24">
              <div className="flex items-start gap-18 mb-24">
                <div className="w-[48px] h-[48px] rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
                  <Icon 
                    name="AlertTriangle" 
                    size={24} 
                    color="var(--color-error)" 
                    strokeWidth={2} 
                  />
                </div>
                <div className="flex-1">
                  <h2 
                    id="delete-confirmation-title"
                    className="font-heading font-semibold text-h4 text-foreground mb-8"
                  >
                    Confirm Deletion
                  </h2>
                  <p className="font-body text-[15px] text-foreground leading-relaxed">
                    {isBulk 
                      ? `Are you sure you want to delete ${itemCount} selected ${itemCount === 1 ? 'entry' : 'entries'}? This action cannot be undone.`
                      : 'Are you sure you want to delete this entry? This action cannot be undone.'
                    }
                  </p>
                </div>
              </div>

              <div className="bg-warning/10 border border-warning/20 rounded-lg p-18 mb-24">
                <div className="flex items-start gap-12">
                  <Icon 
                    name="Info" 
                    size={18} 
                    color="var(--color-warning-foreground)" 
                    strokeWidth={2}
                    className="flex-shrink-0 mt-[2px]" 
                  />
                  <div className="flex-1">
                    <p className="font-body text-[14px] text-warning-foreground leading-relaxed">
                      Deleted entries will be permanently removed from the system and cannot be recovered. All associated audit trail data will also be deleted.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end gap-12">
                <Button
                  variant="outline"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  onClick={onConfirm}
                  iconName="Trash2"
                  iconPosition="left"
                >
                  Delete {isBulk && itemCount > 1 ? `${itemCount} Entries` : 'Entry'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmationModal;